import useReactQuery from '@/hooks/common/useReactQuery';
import { type ParentWithStudents } from '@/interfaces/parent';

interface Params {
  parentId: number;
  code: string;
}

// このフックは API 呼び出しの制御に専念し、UI 副作用（toast / モーダル開閉 / 表示状態）は持たない。
// 呼び出し側が error から表示文言を導出し、onSuccess / onError で UI を制御する。
const useUnlinkParentOrganizationMembership = ({ parentId, code }: Params) => {
  const { useMutation, useQuery } = useReactQuery();

  const { refetch: refetchMe } = useQuery<ParentWithStudents>({
    queryKey: ['me'],
    url: '/api/school/parents/me',
    enabled: false,
  });

  const mutation = useMutation({
    method: 'DELETE',
    url: `/api/school_communication/parents/${parentId}/parent_organization_memberships/${code}`,
  });

  return { ...mutation, refetchMe };
};

export default useUnlinkParentOrganizationMembership;
